import React, { type ReactNode } from "react";
import {
  ScrollView,
  StyleSheet,
  View,
  useWindowDimensions,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import {
  SafeAreaView,
  useSafeAreaInsets,
} from "react-native-safe-area-context";

import { themes } from "@/Components/Styling/themeConfigs";
import AuthHeader from "@/screens/Authentication/Components/AuthHeader/AuthHeader";
import NativeFooter from "@/Components/Footers/Native/NativeFooter";

type AuthLayoutProps = {
  children: ReactNode;
  hideFooter?: boolean;
};

const HEADER_HEIGHT = 200; // Adjust this value based on your actual header height
const FOOTER_HEIGHT = 80; // Adjust this value based on your actual footer height

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  hideFooter = false,
}) => {
  const currentTheme = themes.morning;
  const headerChildrenSpacing = 0;
  const insets = useSafeAreaInsets();
  const { height } = useWindowDimensions();
  const screenHeight = height;

  const contentHeight =
    screenHeight -
    (HEADER_HEIGHT +
      insets.top +
      FOOTER_HEIGHT +
      insets.bottom +
      headerChildrenSpacing);

  return (
    <View style={styles.container}>
      <LinearGradient
        colors={currentTheme.bg}
        style={StyleSheet.absoluteFill}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
      />
      <SafeAreaView
        edges={["top"]}
        style={[styles.header, { height: HEADER_HEIGHT }]}
      >
        <AuthHeader />
      </SafeAreaView>
      <View style={{ height: headerChildrenSpacing }} />
      <ScrollView
        style={[styles.content, { height: contentHeight }]}
        contentContainerStyle={styles.scrollViewContent}
      >
        {children}
      </ScrollView>
      {!hideFooter && (
        <SafeAreaView
          edges={["bottom"]}
          style={[styles.footer, { height: FOOTER_HEIGHT + insets.bottom }]}
        >
          <NativeFooter />
        </SafeAreaView>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    paddingHorizontal: 24,
    justifyContent: "center",
  },
  content: {
    flex: 1,
  },
  scrollViewContent: {
    paddingHorizontal: 24,
    paddingVertical: 16,
  },
  footer: {
    paddingHorizontal: 24,
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
});

export default AuthLayout;
